<template>
  <div class="discard">
    <div class="discard-top">
      <div class="discard-top__name">弃置单</div>
    </div>
    <div class="discard-table">
      <Table :head="discardOrderTableHead" width="1654" height="550"></Table>
    </div>
  </div>
</template>

<script>
import { OrderNewModule } from './class'
import Table from 'components/common/Table.vue'
export default {
  name: 'discardOrder',
  components: {
    Table
  },
  data(){
    return {
      discardOrderTableHead: OrderNewModule.NEWDISCARDORDERTABLEHEAD()
    }
  }
}
</script>

<style lang="scss" scoped>
.discard{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
    &__name{
      font-size: 16px;
      font-weight: bold;
      color: black;
    }
  }
}
</style>
